module.exports = __webpack_public_path__ + "img/it_iron_2019_champion.96dd2514.jpg";